const getPageTitleWithTenantName = (title: string, tenantName?: string | null) =>
  `${title} ${tenantName ? `- ${tenantName}` : ''}`;

export default getPageTitleWithTenantName;
